const DATE_NOW = new Date().getTime();
const URL_TYPE = ['moneydata.hk', 'wechatpay.com.hk', 'res.wx.qq.com'];
const ASSETS_TYPE = ['script', 'link'];

enum CacheType {
  /** 无缓存 */
  noCache = 0,
  /** 部分缓存 */
  partialCache,
  /** 全缓存 */
  allCache,
}

/**
 * 检查资源是否是指定域名内
 */
const checkDomain = (name: string) => URL_TYPE.some(url => name.includes(url));

/**
 * 检查资源类型
 * @param entry
 * @returns
 */
const checkAssetsType = (entry: PerformanceResourceTiming) => ASSETS_TYPE.includes(entry.initiatorType);

/**
 * 只记录在 ASSETS_TYPE 和 固定域名 的资源加载时间
 */
const processEntries = () => {
  if (!window.performance) {
    return [];
  }
  const entries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
  return entries.filter(entry => checkAssetsType(entry) && checkDomain(entry.name));
};

/** 检查缓存类型 */
export const getCacheType = () => {
  const entries = processEntries();
  const len = entries.length;
  // 资源加载完成时间 - 资源开始加载时间 小于 100 ms 认为是本地缓存，但这中策略在 android 手机的误差非常大
  const cacheEntries = entries.filter(entry => entry.responseEnd - entry.startTime <= 100);
  if (cacheEntries.length === 0) {
    return CacheType.noCache;
  }
  if (cacheEntries.length >= len) {
    return CacheType.allCache;
  }
  return CacheType.partialCache;
};

/**
 * 获取页面起始时间
 * @returns
 */
export function getStartTime() {
  // @ts-ignore
  const [pointTime] = window.G_speedPointTime || [];
  const navigationStart = window.performance?.timing?.navigationStart;
  return navigationStart || pointTime || DATE_NOW;
}

/**
 * 检测当前访问的页面版本是否是新构建构建版本
 * @returns
 */
export function isNewVersion(business: string) {
  const version = process.env.VUE_APP_SENTRY_VERSION;
  // 考虑到有的项目可能没有提供这个版本号
  // 这里有版本号标识才去进一步判断是否命中缓存这个特性
  if (!version || !business) {
    return true;
  }
  const cacheKey = `${business}_aegis_build_version`;
  // TODO 这里后续要用通用的localStorage处理方法
  const cacheVersion = localStorage.getItem(cacheKey);
  if (version !== cacheVersion) {
    // 这里存储最新版本
    localStorage.setItem(cacheKey, version);
    return true;
  }
  return false;
}

/**
 * 获取用户UIN
 * @returns
 */
export function getUin() {
  // TODO 后续用cookie公共库
  const ms = document.cookie.match(/qluin=([^;]+)/);
  if (ms) {
    return decodeURIComponent(ms[1]);
  }
  return '';
}
